(function() {
  'use strict';
  var selectedTier = 2;

  window.selectHeroPdpTier = function(el) {
    var tier = parseInt(el.dataset.tier, 10);
    var price = el.dataset.price;
    selectedTier = tier;
    document.querySelectorAll('.hero-pdp-tier').forEach(function(card) { card.classList.remove('selected'); });
    el.classList.add('selected');
    var stickyTierName = document.getElementById('sticky-tier-name');
    if (stickyTierName) {
      var tierNames = { 1: 'Try It', 2: 'The Relief Duo', 3: 'The Complete Relief Kit' };
      stickyTierName.textContent = tierNames[tier] || '';
    }
    var bonus = document.getElementById('bonus-banner');
    if (bonus) bonus.style.display = tier >= 2 ? 'block' : 'none';
    if (window.updateDeliveryLabel) window.updateDeliveryLabel(tier);
  };

  window.changeGalleryImage = function(btn) {
    var src = btn.dataset.src;
    var mainImg = document.getElementById('gallery-main-img');
    if (mainImg && src) mainImg.src = src;
    document.querySelectorAll('.hero-pdp-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  function addToCart() {
    var config = window.heroPdpConfig;
    if (!config) { console.error('Hero PDP: Config not found.'); return; }
    var tierConfig = config.tiers[selectedTier];
    if (!tierConfig) { console.error('Hero PDP: Invalid tier:', selectedTier); return; }

    var items = tierConfig.items.map(function(item) {
      var lineItem = { id: item.id, quantity: item.quantity };
      if (tierConfig.bundleName) { lineItem.properties = { '_bundle': tierConfig.bundleName }; }
      return lineItem;
    });

    var btn = document.getElementById('hero-pdp-atc');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw new Error(err.description || 'Failed to add to cart'); });
      return response.json();
    })
    .then(function() { window.location.href = config.cartUrl; })
    .catch(function(error) {
      console.error('Hero PDP ATC error:', error);
      alert('Sorry, there was an error adding to cart. Please try again.');
    })
    .finally(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Get Relief Now'; }
      if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Get Relief Now'; }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var mainBtn = document.getElementById('hero-pdp-atc');
    if (mainBtn) mainBtn.addEventListener('click', addToCart);
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var mainCta = document.getElementById('hero-pdp-atc');
          var sticky = document.getElementById('sticky-atc');
          if (mainCta && sticky && window.innerWidth <= 768) {
            var rect = mainCta.getBoundingClientRect();
            sticky.classList.toggle('visible', rect.bottom < 0);
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    /* Delivery estimate date calculation + dynamic label */
    var deliveryDateEl = document.getElementById('hero-delivery-date');
    var deliveryLabelEl = document.getElementById('hero-delivery-label');
    if (deliveryDateEl) {
      var freeShipThreshold = window.freeShippingThreshold || 100;
      var tierPrices = { 1: 33.99, 2: 54.99, 3: 84.99 };
      var dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      function addBizDays(start, n) {
        var d = new Date(start); var added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
        return d;
      }
      function fmtDate(d) { return dayNames[d.getDay()] + ', ' + monthNames[d.getMonth()] + ' ' + d.getDate(); }
      var today = new Date();
      deliveryDateEl.textContent = fmtDate(addBizDays(today, 4)) + ' - ' + fmtDate(addBizDays(today, 5));

      window.updateDeliveryLabel = function(tier) {
        if (!deliveryLabelEl) return;
        var price = tierPrices[tier] || 0;
        if (price >= freeShipThreshold) {
          deliveryLabelEl.innerHTML = '<strong>Free Shipping</strong> - Arrives';
        } else {
          deliveryLabelEl.textContent = 'Estimated arrival';
        }
      };
      window.updateDeliveryLabel(selectedTier);
    }

    var bonus = document.getElementById('bonus-banner');
    if (bonus) bonus.style.display = 'block';
  });
})();